function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M114.928 174.046l-28.8 28.8C114.48 109.944 212.776 57.617 305.677 85.969a175.873 175.873 0 0188.851 62.012l25.488-19.312C350.79 37.151 220.481 19.078 128.962 88.304A207.77 207.77 0 0052.64 203.998l-30.016-29.952L0 196.654l68.8 68.8 68.8-68.8-22.672-22.608zM439.68 242.702l-68.8 68.8 22.624 22.624 29.136-29.12c-28.103 93.051-126.317 145.702-219.368 117.599a176.002 176.002 0 01-91.912-65.599l-25.968 18.688a206.719 206.719 0 00135.248 83.824 211.742 211.742 0 0033.76 2.736c95.518-.045 178.669-65.284 201.44-158.048l29.952 29.92 22.688-22.624-68.8-68.8zm-.8 46.096l.816-.816 1.184 1.2-2-.384z"
});

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 508.48 508.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.12fbbf48.svg";
export { ForwardRef as ReactComponent };